module.exports = __webpack_public_path__ + "static/media/dodgem(17).29701011.PNG";